import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Modal as ModalBase } from "reactstrap";
import styles from "./Modal.module.css";

import { modalService } from "services";

const Modal = ({ id = "default-modal" }) => {
  const history = useHistory();
  const [modals, setModals] = useState([]);

  const removeModal = useCallback(
    (modal) => setModals((modals) => modals.filter((m) => m.id !== modal.id)),
    []
  );

  useEffect(() => {
    // subscribe to new modal notifications
    const subscription = modalService.onModal().subscribe((modal) => {
      // close modals when an empty modal is received
      if (!modal.children) {
        removeModal(modal);
      } else {
        // add modal to array
        setModals((modals) => [...modals, modal]);
      }
    });

    // close modals on location change
    const historyUnlisten = history.listen(({ pathname }) => {
      // don't close if pathname has trailing slash because this will be auto redirected again
      if (pathname.endsWith("/")) return;

      modalService.close(id);
    });

    // clean up function that runs when the component unmounts
    return () => {
      // unsubscribe & unlisten to avoid memory leaks
      subscription.unsubscribe();
      historyUnlisten();
    };
  }, [id, removeModal, history]);

  return (
    modals.length > 0 &&
    modals.map((modal, index) => (
      <ModalBase
        className={styles.modal}
        key={`modal-${index}`}
        isOpen={true}
        toggle={() => removeModal(modal)}
      >
        {modal.children}
      </ModalBase>
    ))
  );
};

export { Modal };
